import styled from 'styled-components';
import banner from 'assets/images/banner.png';

export const Wrapper = styled.div`
  background-image: url(${banner});
  background-size: cover;
  background-repeat: no-repeat;
  grid-area: header;
  flex: 1;
  padding: 15px;
  height: 226px;
  text-align: left;
`;

export const SubTitle = styled.h2`
  color: white;
  margin: 0px 0 10px 0;
  font-weight: 100;
  font-size: 16px;
  padding: 0;
`;

export const ButtonWrapper = styled.div`

`;

export const List = styled.ul`
  margin: 0;
  padding: 0 0 0 20px;
`;

export const ListItem = styled.li`
  color: white;
  margin: 5px 0;
  font-size: 12px;
`;

